/**
 * Create the instance of information message element.
 *
 * @param {Application} application
 * @constructor
 */
com.inq.flash.client.control.NotificationController = function(application) {
	this._application = application;
	this._disabled = false;
	this._notifications = {};
	this._countdownTimers = {};
	this._activeNotification = null;
	this._deferredNotification = null;
	this._timerDeferring = null;
	this._disconnectionTimeout = com.inq.flash.client.control.FlashPeer.getDisconnectionTimeout();

	// buffer to save the initial value of bottom position of the chat window
	this._chatBottomPosition = 0;

	this._elementHeight = 0;
	this._elementBottomPosition = 0;
};

/**
 * Hide current Notifications and Disable the Notification Controller
 * to show any new notifications.
 */
com.inq.flash.client.control.NotificationController.prototype.disable = function() {
	this._disabled = true;
	this.clearNotificationTimeout();
	this.hideNotification();
};

/**
 * Initialization of notification settings.
 * Will be reinitialized for each new chat skin.
 * @see com.inq.flash.client.chatskins.SkinControl.ClassInits
 */
com.inq.flash.client.control.NotificationController.prototype.init = function() {
	/** @type {boolean} */
	var isNotificationEnabled = com.inq.utils.Util.getConfig(this.FLAG_NOTIFICATION_ENABLED, false);
	var adBlockNotificationEnabled = com.inq.utils.Util.getConfig(this.FLAG_ADBLOCK_DETECTION_ENABLED, false);

	/** @type {string} */
	var notificationId;

	if (this._deferredNotification) {
		notificationId = this._deferredNotification.getStyle("id");
	} else if (this._activeNotification) {
		notificationId = this._activeNotification.getStyle("id");
	}

	this.clearNotificationTimeout();
	this.hideNotification();

	if (adBlockNotificationEnabled) {
		this._notifications[this.ADBLOCK_DETECTED_MESSAGE_ID] = this._application.getMxmlItem(this.ADBLOCK_DETECTED_MESSAGE_ID);
	}

	if (isNotificationEnabled) {
		this.addNotificationElements();
		this.setupCountdownTimer(this.CONNECTION_ISSUES_MESSAGE_ID);
		this.reactivateNotification(notificationId);
	} else {
		// clear notifications and countdown timers
		if (!adBlockNotificationEnabled) {
			this._notifications = {};
		}
		this._countdownTimers = {};
	}

	if (notificationId === this.ADBLOCK_DETECTED_MESSAGE_ID){
		this.showAdblockDetectedMessage();
	}
};

/**
 * Reactivate notification during the reinitialization if it was active previously.
 * @param {string} notificationId
 */
com.inq.flash.client.control.NotificationController.prototype.reactivateNotification = function(notificationId) {
	switch (notificationId) {
		case this.CONNECTION_ISSUES_MESSAGE_ID:
			this.showConnectionIssuesMessage();
			break;

		case this.CONNECTION_RESTORED_MESSAGE_ID:
			this.showConnectionRestoredMessage();
			break;

		case this.CONNECTION_FAILED_MESSAGE_ID:
			this.showConnectionFailedMessage();
			break;
	}
};

/**
 * Add all defined notifications from MXML skin configuration by predefined id.
 */
com.inq.flash.client.control.NotificationController.prototype.addNotificationElements = function() {
	this._notifications[this.CONNECTION_ISSUES_MESSAGE_ID] = this._application.getMxmlItem(this.CONNECTION_ISSUES_MESSAGE_ID);
	this._notifications[this.CONNECTION_RESTORED_MESSAGE_ID] = this._application.getMxmlItem(this.CONNECTION_RESTORED_MESSAGE_ID);
	this._notifications[this.CONNECTION_FAILED_MESSAGE_ID] = this._application.getMxmlItem(this.CONNECTION_FAILED_MESSAGE_ID);
};

/**
 * Add the CountdownTimer instance to specified notification,
 * if it contains the predefined template to replace it on dynamic countdown timer element.
 * @param {string} notificationId
 */
com.inq.flash.client.control.NotificationController.prototype.setupCountdownTimer = function(notificationId) {
	if (this._notifications[notificationId]) {
		var messageContainer = this._notifications[notificationId].getChildren();
		if (messageContainer && messageContainer[0]) {
			var messageText = messageContainer[0].getText();
			if (messageText.indexOf(com.inq.ui.CountdownTimer.TEMPLATE_MARKER) != -1) {
				this._countdownTimers[notificationId] = new com.inq.ui.CountdownTimer(messageContainer[0]);
				this._countdownTimers[notificationId].addEndingListener(com.inq.flash.client.chatskins.SkinControl.connectionLostClosingChat);
			}
		}
	}
};

/**
 * Checks the activity of notification.
 * @returns {boolean}
 */
com.inq.flash.client.control.NotificationController.prototype.notificationIsActive = function() {
	return this._activeNotification != null;
};

/**
 * Shows the corresponding notification (the element of chat skin).
 *
 * @param {string} notificationId
 */
com.inq.flash.client.control.NotificationController.prototype.showNotification = function(notificationId) {
	if (this._disabled) {
		return;
	}

	this._activeNotification = this._deferredNotification || this._notifications[notificationId];
	if (this._activeNotification) {
		var countdownTimer = this._countdownTimers[notificationId];
		if (countdownTimer) {
			var connectionLag = Date.now() - this.getLastResponseTimestamp();
			countdownTimer.setPeriod(this._disconnectionTimeout - connectionLag);
			countdownTimer.start();
		}
		this._activeNotification.setVisible(true);

		this._elementHeight = this._activeNotification.getHeight();
		this._elementBottomPosition = Std.parseInt(this._activeNotification.getStyle("bottom"));

		this.updatePosition();

		if (this._deferredNotification) {
			this._deferredNotification = null;
			this._timerDeferring = null;
		}

		var notificationTextNodes = this._activeNotification.getChildren();
		var ariaMessage = "";
		var length = notificationTextNodes.length;

		for (var i = 0; i < length; i++) {
			if (notificationTextNodes[i]._div.innerText) {
				ariaMessage += notificationTextNodes[i]._div.innerText + " ";
			}
		}
		com.inq.aria.AriaMsg.addAriaMsg(ariaMessage);
	}
};

/**
 * Hides the active notification.
 */
com.inq.flash.client.control.NotificationController.prototype.hideNotification = function() {
	if (this._activeNotification) {
		/** @type {string} */
		var notificationId = this._activeNotification.getStyle("id");
		/** @type {com.inq.ui.CountdownTimer} */
		var countdownTimer = this._countdownTimers[notificationId];
		if (countdownTimer) {
			countdownTimer.stop();
		}
		this._activeNotification.setVisible(false);
		this.updatePosition();
		this._activeNotification = null;
	}
};

/**
 * Shows the corresponding notification after specified delay,
 *   if the element of chat skin is exist.
 *
 * @param {string} notificationId
 * @param {number} delay
 * @param {boolean} hideInputField
 */
com.inq.flash.client.control.NotificationController.prototype.setNotificationTimeout = function(notificationId, delay, hideInputField) {
	if (this._disabled) {
		return;
	}

	this._deferredNotification = this._notifications[notificationId];
	if (this._deferredNotification) {
		this._timerDeferring = setTimeout(function() {
			this.hideNotification();
			this.showNotification(notificationId);
			if (hideInputField) {
				com.inq.flash.client.chatskins.SkinControl.hideInput();
			}
		}.bind(this), delay);
	}
};

/**
 * Cancels the deferred notification.
 * @see this.setNotificationTimeout
 */
com.inq.flash.client.control.NotificationController.prototype.clearNotificationTimeout = function() {
	if (this._deferredNotification && this._timerDeferring) {
		clearTimeout(this._timerDeferring);
		this._deferredNotification = null;
		this._timerDeferring = null;
	}
};

/**
 * Shows the notification about the issue with connection.
 */
com.inq.flash.client.control.NotificationController.prototype.showConnectionIssuesMessage = function() {
	if (this._disabled) {
		return;
	}

	var connectionLag = Date.now() - this.getLastResponseTimestamp();
	var displayDelay = this.DISPLAY_DELAY - connectionLag;
	if (displayDelay < 0) {
		displayDelay = 0;
	}
	if (this._deferredNotification) {
		// Cancel the deferred notification if it is not CONNECTION_ISSUES_MESSAGE_ID.
		// If the deferred notification is CONNECTION_ISSUES_MESSAGE_ID then not needed to cancel it.
		if (this.CONNECTION_ISSUES_MESSAGE_ID != this._deferredNotification.getStyle("id")) {
			this.clearNotificationTimeout();
			this.setNotificationTimeout(this.CONNECTION_ISSUES_MESSAGE_ID, displayDelay, true);
		}
	} else {
		if (!this._activeNotification || this.CONNECTION_ISSUES_MESSAGE_ID != this._activeNotification.getStyle("id")) {
			this.setNotificationTimeout(this.CONNECTION_ISSUES_MESSAGE_ID, displayDelay, true);
		}
	}
};

/**
 * Shows the notification about restoring of connection.
 */
com.inq.flash.client.control.NotificationController.prototype.showConnectionRestoredMessage = function() {
	if (this._disabled) {
		return;
	}

	if (this._deferredNotification && this.CONNECTION_ISSUES_MESSAGE_ID == this._deferredNotification.getStyle("id")) {
		this.clearNotificationTimeout();
	} else if (this._activeNotification && this.CONNECTION_ISSUES_MESSAGE_ID == this._activeNotification.getStyle("id")) {
		this.hideNotification();
		this.showNotification(this.CONNECTION_RESTORED_MESSAGE_ID);
		if (this._application.applicationController.isConnected()) {
			com.inq.flash.client.chatskins.SkinControl.showInput();
		}
	}
	com.inq.flash.client.chatskins.SkinControl.getTextInputField().setFocus(true);
};

/**
 * Shows the notification about failing of connection and loss of a chat.
 */
com.inq.flash.client.control.NotificationController.prototype.showConnectionFailedMessage = function() {
	if (this._disabled) {
		return;
	}

	if (!this._activeNotification || this.CONNECTION_FAILED_MESSAGE_ID != this._activeNotification.getStyle("id")) {
		this.hideNotification();
		this.showNotification(this.CONNECTION_FAILED_MESSAGE_ID);
		com.inq.flash.client.chatskins.SkinControl.hideInput();
	}
};
/**
 * Shows notification informing web chat client that adblock(or similar) is enabled in her browser.
 */
com.inq.flash.client.control.NotificationController.prototype.showAdblockDetectedMessage = function () {
	if (this._disabled) {
		return;
	}

	this.hideNotification();
	this._activeNotification = this._notifications[this.ADBLOCK_DETECTED_MESSAGE_ID];
	if (this._activeNotification) {
		this._activeNotification.setVisible(true);
	}
	var textItems = this._activeNotification.getChildren();
	var notificationMessage = "";

	textItems.forEach(function(textItem) {
		if (textItem._div.innerText) {
			notificationMessage += textItem._div.innerText + " ";
		}
	});

	com.inq.aria.AriaMsg.addAriaMsg(notificationMessage);
	com.inq.flash.client.chatskins.SkinControl.hideInput();
	this.updatePosition();
};

com.inq.flash.client.control.NotificationController.prototype.updatePosition = function() {
	/** @type {string} */
	var notificationId = this._activeNotification.getStyle("id");
	/** @type {com.inq.ui.TextArea} */
	var chatWindowElement = this._application.getMxmlItem("chatWindow");
	/**	@type {com.inq.ui.Canvas} */
	var connectionRestoredMessage = this._application.getMxmlItem("connectionRestoredMessage");
	/**	@type {number} */
	var notificationBottomDefaultValue = connectionRestoredMessage ? Std.parseInt(connectionRestoredMessage.getStyle("bottom")) : 0;
	/** @type {number} */
	var chatBottomPosition = Std.parseInt(chatWindowElement.getStyle("bottom")) || notificationBottomDefaultValue;

	if (this._activeNotification.getVisible()) {
		this._chatBottomPosition = chatBottomPosition;

		if (this.CONNECTION_RESTORED_MESSAGE_ID == notificationId) {
			this._elementBottomPosition = this._chatBottomPosition;
			this._activeNotification.setStyle("bottom", "" + this._elementBottomPosition);
			this._activeNotification.setStyle("left", chatWindowElement.getStyle("left"));
			this._activeNotification.setStyle("right", chatWindowElement.getStyle("right"));
		}

		if (this._elementBottomPosition + this._elementHeight > chatBottomPosition) {
			chatWindowElement.setStyle("bottom", "" + (this._elementBottomPosition + this._elementHeight));
		}
	} else {
		chatWindowElement.setStyle("bottom", "" + this._chatBottomPosition);
	}

	com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();

	// TODO: RTDEV-16275 - add accessibility (CATO) below
};

/**
 * Response timestamp is used for detection the last successful response from the server
 * to monitor the time of the connection issue.
 * If returns 0 that means the response had not received even once.
 * @returns {number}
 */
com.inq.flash.client.control.NotificationController.prototype.getLastResponseTimestamp = function() {
	return this._application.applicationController.getResponseTimestamp();
};

/** @type {string} */
com.inq.flash.client.control.NotificationController.prototype.FLAG_NOTIFICATION_ENABLED = "disconnectionNotification";
/** @type {string} */
com.inq.flash.client.control.NotificationController.prototype.FLAG_ADBLOCK_DETECTION_ENABLED = "adblockDetectionEnabled";
/** @type {string} */
com.inq.flash.client.control.NotificationController.prototype.CONNECTION_ISSUES_MESSAGE_ID = "connectionIssuesMessage";
/** @type {string} */
com.inq.flash.client.control.NotificationController.prototype.CONNECTION_RESTORED_MESSAGE_ID = "connectionRestoredMessage";
/** @type {string} */
com.inq.flash.client.control.NotificationController.prototype.CONNECTION_FAILED_MESSAGE_ID = "connectionFailedMessage";
/** @type {string} */
com.inq.flash.client.control.NotificationController.prototype.ADBLOCK_DETECTED_MESSAGE_ID = "adblockDetectedMessage";
/** @type {number} */
com.inq.flash.client.control.NotificationController.prototype.DISPLAY_DELAY = 15000;